import moment from 'moment';

import validators from '@utils/validators';
import {NOTES_LIMIT, DESCRIPTION_LIMIT, EXTERNAL_DESCRIPTION_LIMIT} from '@constants/variables';


const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.property_licence, 'property_licence'));
    Object.assign(errors, validators.required(values.content_category, 'content_category'));
    Object.assign(errors, validators.dateTime(values.start_datetime, 'start_datetime'));

    if (values.end_datetime && moment(values.start_datetime).isAfter(values.end_datetime)) {
        Object.assign(errors, {end_datetime: 'End date must be later than the Start date'});
    }

    Object.assign(errors, validators.required(values.event_status, 'event_status'));
    Object.assign(errors, validators.maxLength({value: values.description, maxLength: DESCRIPTION_LIMIT}, 'description'));
    Object.assign(errors, validators.maxLength({value: values.external_description, maxLength: EXTERNAL_DESCRIPTION_LIMIT}, 'external_description'));
    Object.assign(errors, validators.maxLength({value: values.notes, maxLength: NOTES_LIMIT}, 'notes'));

    if (values.preset_save) {
        Object.assign(errors, validators.required(values.preset_name, 'preset_name'));
    }

    return errors;
};

export const validateForEventMultiple = (values) => {
    const errors ={};

    Object.assign(errors, validators.required(values.property_licence, 'property_licence'));
    Object.assign(errors, validators.required(values.event_status, 'event_status'));
    Object.assign(errors, validators.maxLength({value: values.external_description, maxLength: EXTERNAL_DESCRIPTION_LIMIT}, 'external_description'));
    Object.assign(errors, validators.maxLength({value: values.notes, maxLength: NOTES_LIMIT}, 'notes'));

    return errors;
};

export const validateForEventMultiplePresetApply = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.event_preset, 'event_preset'));
    Object.assign(errors, validators.maxLength({value: values.notes, maxLength: NOTES_LIMIT}, 'notes'));
    Object.assign(errors, validators.maxLength({value: values.external_description, maxLength: EXTERNAL_DESCRIPTION_LIMIT}, 'external_description'));

    return errors;
};

export const validateForExistingEvent = (values, props) => {
    const errors = validate(values, props);

    delete errors.content_category;

    return errors;
};

export const validateForNonExistingEvent = (values, props) => {
    const errors = validateForExistingEvent(values, props);

    Object.assign(errors, validators.required(values.tournament_id, 'tournament_id'));

    return errors;
};

export default validate;
